import initCarousel from '../helpers/carousel';

export default class DynamicLogoCarousel {
  constructor(section) {
    this.el = section.el;
    this.section = section;

    initCarousel(
      this.el,
      {
        autoWidth: true,
        perMove: 1,
        type: 'loop',
        gap: '2rem',
        autoplay: true,
        arrows: false,
        pagination: false,
      },
      true,
    );
  }
}
